exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-styles-components-checkout-steps-___delivery-form__deliveryFormShipments___2LygC{padding-left:25px;padding-right:25px;border-style:none;background-color:#e9e9e8}", ""]);

// exports
exports.locals = {
	"deliveryFormShipments": "src-components-styles-components-checkout-steps-___delivery-form__deliveryFormShipments___2LygC"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/styles/components/checkout-steps/delivery-form.scss
 ** module id = 907
 ** module chunks = 0
 **/